import { useQuery } from '@tanstack/react-query';

import { useAxios } from './useAxios';

export interface AgentSummary {
  name: string;
  title: string;
  description: string;
  nonPraetorian: boolean;
}

export const useAIAgents = () => {
  const axios = useAxios();

  return useQuery({
    queryKey: ['ai-agents'],
    queryFn: async () => {
      const response = await axios.get<AgentSummary[]>('/agents');
      return response.data;
    },
    staleTime: 300000, // 5min - agents rarely change
    gcTime: 600000, // 10min cache retention
  });
};
